// extracted by mini-css-extract-plugin
export default {"container":"PrevPageComponent_container__S6JUo","navLink":"PrevPageComponent_navLink__6zcRU"};